module.exports = __webpack_public_path__ + "img/type3@3x.40cb07e5.png";